module.exports = __webpack_public_path__ + "static/media/mark.0c0ddfee.svg";